import { getCookie } from 'cookies-next'

// facebook cookie
// Format: fb.{subdomainIndex}.{creationTime}.{fbclid}
// https://developers.facebook.com/docs/marketing-api/conversions-api/parameters/fbp-and-fbc#2--format-clickid
export function getFbcCookie() {
  if (typeof window !== 'undefined') {
    const fbclid = new URLSearchParams(window.location.search).get('fbclid')
    if (fbclid) {
      return `fb.1.${Date.now()}.${fbclid}`
    }
  }
  return getCookie('_fbc') || null
}

export function getFbpCookie() {
  return getCookie('_fbp') || null
}
